import React, { useContext } from 'react';
import { Fade } from 'react-awesome-reveal';
import { ThemeContext } from '../../contexts/ThemeContext';

import eduImgWhite from '../../assets/svg/education/eduImgWhite.svg';
import './Education.css';

function EducationCard({
    id,
    institution,
    course,
    startYear,
    endYear,
    score
}) {

    const { theme } = useContext(ThemeContext);

    return (
        <Fade direction="up" triggerOnce>
            <div
                key={id}
                className="education-card modern-education-card"
            >

                <div
                    className="educard-img"
                    style={{
                        background: `linear-gradient(135deg, ${theme.primary}, ${theme.primary80 || theme.primary})`
                    }}
                >
                    <img src={eduImgWhite} alt="education" />
                </div>

                <div className="education-year">
                    <span>{startYear} - {endYear}</span>
                </div>

                <div className="education-course">
                    <h4>{course}</h4>
                </div>

                <div className="education-institute">
                    <h5>{institution}</h5>
                </div>

                {score && (
                    <div className="education-score">
                        ⭐ {score}
                    </div>
                )}

            </div>
        </Fade>
    );
}

export default EducationCard;